import axios from "axios";

const BASE_URL = "http://127.0.0.1:47832/api";

export const api = axios.create({
  baseURL: BASE_URL,
  timeout: 600000,
});

// Backend status checker
export async function checkBackend() {
  try {
    const res = await axios.get(`${BASE_URL}/test`);
    return res.status === 200;
  } catch (err) {
    return false;
  }
}

export async function getVersion() {
  try {
    const res = await api.get("/version");
    return res.data?.version || "Unknown";
  } catch (err) {
    return "Offline";
  }
}